export const FETCH_USERS_REQUESTED        = 'users/FETCH_USERS_REQUESTED'
export const FETCH_USERS_SUCCEED          = 'users/FETCH_USERS_SUCCEED'
export const FETCH_USERS_FAIL             = 'users/FETCH_USERS_FAIL'
export const FETCH_USER_REQUESTED         = 'users/FETCH_USER_REQUESTED'
export const FETCH_USER_SUCCEED           = 'users/FETCH_USER_SUCCEED'
export const FETCH_USER_FAIL              = 'users/FETCH_USER_FAIL'
export const EDIT_USER_REQUESTED          = 'users/EDIT_USER_REQUESTED'
export const EDIT_USER_SUCCEED            = 'users/EDIT_USER_SUCCEED'
export const EDIT_USER_FAIL               = 'users/EDIT_USER_FAIL'
export const FETCH_USER_PHOTO_REQUESTED   = 'users/FETCH_USER_PHOTO_REQUESTED'
export const FETCH_USER_PHOTO_SUCCEED   = 'users/FETCH_USER_PHOTO_SUCCEED'
export const FETCH_USER_PHOTO_FAIL   = 'users/FETCH_USER_PHOTO_FAIL'
export const FETCH_USER_PHOTO_UPLOAD_REQUESTED   = 'users/FETCH_USER_PHOTO_UPLOAD_REQUESTED'
export const FETCH_USER_PHOTO_UPLOAD_SUCCEED   = 'users/FETCH_USER_PHOTO_UPLOAD_SUCCEED'
export const FETCH_USER_PHOTO_UPLOAD_FAIL   = 'users/FETCH_USER_PHOTO_UPLOAD_FAIL'
export const FETCH_USER_PHOTO_SELECT   = 'users/FETCH_USER_PHOTO_SELECT'
export const FETCH_USER_PHOTO_SAVE_REQUESTED   = 'users/FETCH_USER_PHOTO_SAVE_REQUESTED'
export const FETCH_USER_PHOTO_SAVE_SUCCEED   = 'users/FETCH_USER_PHOTO_SAVE_SUCCEED'
export const FETCH_USER_PHOTO_SAVE_FAIL   = 'users/FETCH_USER_PHOTO_SAVE_FAIL'



// WEBPACK FOOTER //
// ./src/store/users/actionTypes.js